import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WorkRequestsDashboardLayer from "../components/dashboards/WorkRequestsDashboardLayer";

const WorkRequestsDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Work Requests Dashboard">
        <WorkRequestsDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default WorkRequestsDashboardPage;
